export const GET_CONFIGURATION_DETAILS_REQUEST =
  "GET_CONFIGURATION_DETAILS_REQUEST";
export const GET_CONFIGURATION_DETAILS_SUCCESS =
  "GET_CONFIGURATION_DETAILS_SUCCESS";
export const GET_CONFIGURATION_DETAILS_FAILURE =
  "GET_CONFIGURATION_DETAILS_FAILURE";

export const ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST =
  "ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST";
export const ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS =
  "ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS";
export const ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE =
  "ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE";
